import { useLoading } from "shared/contexts/Loading";

// Displays a spinning loader when global loading state is true.
const GlobalLoader = () => {
    const { isLoading } = useLoading();
    if (!isLoading) return null;

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-75 flex items-center justify-center z-40">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-500"></div>
        </div>
    );
};
export default GlobalLoader;
